import type { InitialConfigType } from '@lexical/react/LexicalComposer';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { CodeNode, CodeHighlightNode } from '@lexical/code';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { ListNode, ListItemNode } from '@lexical/list';
import { SpoilerNode, ExpandableQuoteNode, CustomEmojiNode } from './nodes';
import { telegramEditorTheme } from './theme';

export const editorConfig: InitialConfigType = {
  namespace: 'TelegramPostEditor',
  theme: telegramEditorTheme,
  nodes: [
    HeadingNode, // Not used for Telegram output but useful for paste handling
    QuoteNode, // Built-in blockquote — maps to Telegram blockquote entity
    CodeNode, // Code blocks with optional language
    CodeHighlightNode, // Syntax highlighting within code blocks
    LinkNode, // Inline links and tg://user?id= mentions
    AutoLinkNode, // Auto-detect URLs while typing
    ListNode, // Not a Telegram entity; converted to plain text on export
    ListItemNode, // Paired with ListNode
    SpoilerNode, // Custom — Telegram spoiler entity
    ExpandableQuoteNode, // Custom — Telegram expandable_blockquote entity
    CustomEmojiNode, // Custom — Telegram custom_emoji entity (Phase 2)
  ],
  onError: (error: Error) => {
    // Surfaced via Lexical's ErrorBoundary; logged to console for dev visibility.
    console.error('[lexicalEditor] Editor error:', error.message);
  },
};

/** Message character limit (UTF-16 code units) */
export const MESSAGE_CHAR_LIMIT = 4096;

/** Caption character limit (UTF-16 code units) */
export const CAPTION_CHAR_LIMIT = 1024;
